import React from "react";
import "@/animations/animate.css";


// @ts-ignore

import { motion, useScroll, useSpring, useTransform } from 'framer-motion';
import AnimatedBody from "@/animations/AnimatedBody";
import AnimatedLetters from "@/animations/AnimatedLetters";
import { Ivy } from "@/fonts/spaceGrotesk";
// @ts-ignore

import Badge from "@/components/ui/badge";
import PlanetLottie from "./planetlottie";
const Planets = ({certificate } : any ) => {
    const ref = React.useRef(null)
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "100vh"]
    
    })
  
    const transform = useTransform(
      scrollYProgress,
      [0, 1],
      [0,90]
    )
  
    const [result, setResult] = React.useState('');
    // @ts-ignore
const [load , setLoad] = React.useState(false);

    React.useEffect(() => {
    
        async function getdata() {
       
            
            const havadurumu = await fetch(`${process.env.NEXT_PUBLIC_URL}/api/planets?certificate=${certificate}`);
            const havadurumu2 = await havadurumu.json();
            console.log(havadurumu2)
            setLoad(true)
            setResult(havadurumu2)
        }
    
        getdata();
    
    }
    , [])
  
    const physics = { damping: 15, mass: 0.27, stiffness: 55 }
    // @ts-ignore
const rotateZ = useSpring(transform, physics)

    return (
        <>

        <section
            ref={ref}
            className="relative min-h-screen z-10 0 w-screen  items-center justify-center overflow-hidden bg-black bg-cover bg-center pt-16 pb-36 md:pt-20 md:pb-44 lg:pt-20 lg:pb-56"
            id="Planets"
        >
           




            <div className="mx-auto flex w-full flex-col items-center justify-center">
         <PlanetLottie />
            <div className="mx-auto flex  flex-col items-center gap-1.5   ">
              
                    <AnimatedLetters style={`font-black items-center  ms-5 justify-center font-normal !max-w-[100%]  leading-[1] sm:text-[6.5rem] text-[3rem] flex flex-row text-center m-0 ${Ivy.className}`}
                    title={`Gökyüzünü Süsleyen`} />
   <AnimatedBody underline={true} underlineColor="#942828" delay={0.2} className="text-[3rem]    leading-[1] !text-[#fff] sm:text-[4.5rem] font-black text-center m-0"
                    text={`Gezegenler`} />

<AnimatedBody delay={0.2}
                    className="text-2xl p-6 my-3 w-[100%] sm:text-2xl font-normal text-center !text-opacity-100 !text-white-vibrant "
                    text={`${result}

                    `} />

                    
                </div>
               
            </div>
        </section></>
    );
};

export default Planets;
